import { render, staticRenderFns } from "./pcdd.vue?vue&type=template&id=ebb12ba4&scoped=true"
import script from "./pcdd.vue?vue&type=script&lang=js"
export * from "./pcdd.vue?vue&type=script&lang=js"
import style0 from "./pcdd.vue?vue&type=style&index=0&id=ebb12ba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb12ba4",
  null
  
)

export default component.exports